import React from "react";
import Navbar from "./components/Navbar";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages/home";
import Skills from "./pages/skills";
import Projects from "./pages/projects";
import Writing from "./pages/writing";

function App() {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/projects"element={<Projects />} />
                <Route path="/writing" element={<Writing />} />
            </Routes>
        </Router>
    );
}

export default App;